import './component-categories.scss'
import ComponentBase from './component-base';
import { html } from 'lit';

class ComponentCategories extends ComponentBase {
    static get tagName() { return 'component-categories' }

    constructor() {
        super();
        this.categories = [
            {
                id: 1,
                label: 'Cibi'
            },
            {
                id: 0,
                label: 'Bevande'
            }
        ]
        this.activeCategoriesId = [];
    }

    _OnCategory(e, category) {
        if (this.activeCategoriesId.indexOf(category.id) !== -1) {
            this.activeCategoriesId.splice(this.activeCategoriesId.indexOf(category.id), 1);
        } else {

            this.activeCategoriesId.push(category.id);
        }
        this.requestUpdate();
        this.dispatchEvent(new CustomEvent('categoryChange', {
            detail: { activeCategories: this.activeCategoriesId },
            bubbles: true,
            composed: true
        }))

    }

    render() {
        return html`
            <ul class="nav nav-pills">
                ${this.categories.map(category => html`
                <li class="nav-item">
                    <button 
                        @click=${e => this._OnCategory(e, category)}
                        class="nav-link ${this.activeCategoriesId.includes(category.id) ? 'active' : ''}"
                    >
                        ${category.label}
                    </button>
                </li>`)}
            </ul>
        `
    }
}
ComponentCategories.Register();
export default ComponentCategories;